/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetDiagnosticDownloadResponseDto,
  AssetDiagnosticResponseDto,
  ListAssetDiagnosticsResponseDto,
} from '../models/index';
import {
    AssetDiagnosticDownloadResponseDtoFromJSON,
    AssetDiagnosticDownloadResponseDtoToJSON,
    AssetDiagnosticResponseDtoFromJSON,
    AssetDiagnosticResponseDtoToJSON,
    ListAssetDiagnosticsResponseDtoFromJSON,
    ListAssetDiagnosticsResponseDtoToJSON,
} from '../models/index';

export interface OcppDiagnosticsQueryControllerCancelRequest {
    diagnosticId: any;
    assetId: any;
    organizationId: any;
}

export interface OcppDiagnosticsQueryControllerDownloadRequest {
    diagnosticId: any;
    assetId: any;
    organizationId: any;
}

export interface OcppDiagnosticsQueryControllerGetByIdRequest {
    diagnosticId: any;
    assetId: any;
    organizationId: any;
}

export interface OcppDiagnosticsQueryControllerListRequest {
    limit: number;
    page: number;
    assetId: any;
    organizationId: any;
}

/**
 * 
 */
export class AssetOCPPDiagnosticsApi extends runtime.BaseAPI {

    /**
     * Cancel a waiting GetDiagnostics (REQUESTED or ACCEPTED only; not UPLOADING)
     */
    async ocppDiagnosticsQueryControllerCancelRaw(requestParameters: OcppDiagnosticsQueryControllerCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDiagnosticResponseDto>> {
        if (requestParameters['diagnosticId'] == null) {
            throw new runtime.RequiredError(
                'diagnosticId',
                'Required parameter "diagnosticId" was null or undefined when calling ocppDiagnosticsQueryControllerCancel().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ocppDiagnosticsQueryControllerCancel().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling ocppDiagnosticsQueryControllerCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-diagnostics/{diagnosticId}/cancel`;
        urlPath = urlPath.replace(`{${"diagnosticId"}}`, encodeURIComponent(String(requestParameters['diagnosticId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDiagnosticResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel a waiting GetDiagnostics (REQUESTED or ACCEPTED only; not UPLOADING)
     */
    async ocppDiagnosticsQueryControllerCancel(requestParameters: OcppDiagnosticsQueryControllerCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDiagnosticResponseDto> {
        const response = await this.ocppDiagnosticsQueryControllerCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a short-lived presigned download URL (requires UPLOADED + object present)
     */
    async ocppDiagnosticsQueryControllerDownloadRaw(requestParameters: OcppDiagnosticsQueryControllerDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDiagnosticDownloadResponseDto>> {
        if (requestParameters['diagnosticId'] == null) {
            throw new runtime.RequiredError(
                'diagnosticId',
                'Required parameter "diagnosticId" was null or undefined when calling ocppDiagnosticsQueryControllerDownload().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ocppDiagnosticsQueryControllerDownload().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling ocppDiagnosticsQueryControllerDownload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-diagnostics/{diagnosticId}/download`;
        urlPath = urlPath.replace(`{${"diagnosticId"}}`, encodeURIComponent(String(requestParameters['diagnosticId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDiagnosticDownloadResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get a short-lived presigned download URL (requires UPLOADED + object present)
     */
    async ocppDiagnosticsQueryControllerDownload(requestParameters: OcppDiagnosticsQueryControllerDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDiagnosticDownloadResponseDto> {
        const response = await this.ocppDiagnosticsQueryControllerDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one GetDiagnostics workflow by id
     */
    async ocppDiagnosticsQueryControllerGetByIdRaw(requestParameters: OcppDiagnosticsQueryControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDiagnosticResponseDto>> {
        if (requestParameters['diagnosticId'] == null) {
            throw new runtime.RequiredError(
                'diagnosticId',
                'Required parameter "diagnosticId" was null or undefined when calling ocppDiagnosticsQueryControllerGetById().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ocppDiagnosticsQueryControllerGetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling ocppDiagnosticsQueryControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-diagnostics/{diagnosticId}`;
        urlPath = urlPath.replace(`{${"diagnosticId"}}`, encodeURIComponent(String(requestParameters['diagnosticId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDiagnosticResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get one GetDiagnostics workflow by id
     */
    async ocppDiagnosticsQueryControllerGetById(requestParameters: OcppDiagnosticsQueryControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDiagnosticResponseDto> {
        const response = await this.ocppDiagnosticsQueryControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List GetDiagnostics history for an asset (newest first, paginated)
     */
    async ocppDiagnosticsQueryControllerListRaw(requestParameters: OcppDiagnosticsQueryControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetDiagnosticsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling ocppDiagnosticsQueryControllerList().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling ocppDiagnosticsQueryControllerList().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ocppDiagnosticsQueryControllerList().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling ocppDiagnosticsQueryControllerList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-diagnostics`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetDiagnosticsResponseDtoFromJSON(jsonValue));
    }

    /**
     * List GetDiagnostics history for an asset (newest first, paginated)
     */
    async ocppDiagnosticsQueryControllerList(requestParameters: OcppDiagnosticsQueryControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetDiagnosticsResponseDto> {
        const response = await this.ocppDiagnosticsQueryControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
